module.exports = __webpack_public_path__ + "media/assets/images/solutions/effective_communication/hero_image-8e1a6177d6e6e24984a6a7eb6f634e61.png";